import { VerificationType } from 'services/EpdClient';

export default function getVerificationTypeLabel(verificationType: string) {
  switch (verificationType) {
    case VerificationType.EPDVerification:
      return 'Individual EPD verification';
    case VerificationType.EPDProcessCertification:
      return 'EPD Process Certification';
    case VerificationType.EPDPreverifiedTool:
      return 'Fully pre-verified EPD tool';
    default:
      throw new Error('Invalid verification type has been passed.');
  }
}
